// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue';
import 'babel-polyfill';
import 'unorm';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import App from './app.vue';
import Vue2Filters from 'vue2-filters';
import Vuelidate from 'vuelidate';
import VueScrollTo from 'vue-scrollto';
import { BootstrapVue } from 'bootstrap-vue';
import moment from 'moment';

import router from './router';
import * as config from './shared/config/config';
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue';
import JhiItemCountComponent from './shared/jhi-item-count.vue';
import JhiSortIndicatorComponent from './shared/sort/jhi-sort-indicator.vue';
import ActivateService from './bo/pages/account/activate/activate.service';
import RegisterService from './bo/pages/account/register/register.service';

import UserManagementService from '@/bo/pages/admin/user-management/user-management.service';
import AuditsService from './bo/pages/admin/audits/audits.service';

import LoginService from './bo/pages/account/login.service';
import AccountService from './bo/pages/account/account.service';

import '../content/scss/vendor.scss';
import 'leaflet/dist/leaflet.css';
import '../content/css/app.css';
import '../content/css/loading.css';
import AlertService from '@/shared/alert/alert.service';
import TranslationService from '@/locale/translation.service';
import JhiDataUtils from '@/shared/data/data-utils.service';
import DateUtils from '@/shared/date/date-utils.service';
import CaptchetatService from '@/fo/components/captchetat/captchetat.service';

import PageHeader from '@/fo/components/page-header/page-header.vue';
import InscriptionPage from '@/fo/pages/inscription-page/inscription-page.vue';
import CgvPage from '@/fo/pages/cgv-page/cgv-page.vue';
import MapSessions from './fo/components/map-sessions/map-sessions.vue';
import InscriptionForm from './fo/components/inscription-form/inscription-form.vue';
import SearchSessionsForm from './fo/components/search-sessions-form/search-sessions-form.vue';
import SessionCard from './fo/components/session-card/session-card.vue';
import AutocompletionLocation from './fo/components/autocompletion-location/autocompletion-location.vue';

/* tslint:disable */
import ExamCenterService from '@/bo/pages/entities/exam-center/exam-center.service';
import ExamSessionService from '@/bo/pages/entities/exam-session/exam-session.service';
import InscriptionService from '@/bo/pages/entities/inscription/inscription.service';
import ApplicationService from '@/shared/application.service';
import AutocompletionLocationService from '@/fo/components/autocompletion-location/autocompletion-location.service';
import PaymentService from '@/fo/pages/payment/payment.service';
import ServiceRegionalService from '@/bo/pages/entities/service-regional/service-regional.service';

// jhipster-needle-add-entity-service-to-main-import - JHipster will import entities services here

/* tslint:enable */
Vue.config.productionTip = false;

config.initVueApp(Vue);
config.initFortAwesome(Vue);
bootstrapVueConfig.initBootstrapVue(Vue);
Vue.use(BootstrapVue);
Vue.use(Vue2Filters);
Vue.use(Vuelidate);
Vue.use(require('vue-moment'));
//this.$moment.locale(myNewLocale)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
});

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('jhi-item-count', JhiItemCountComponent);
Vue.component('jhi-sort-indicator', JhiSortIndicatorComponent);
// Vue.component('infinite-loading', InfiniteLoading);
Vue.component('map-sessions', MapSessions);
Vue.component('inscription-form', InscriptionForm);
Vue.component('search-sessions-form', SearchSessionsForm);
Vue.component('session-card', SessionCard);
Vue.component('autocompletion-location', AutocompletionLocation);
Vue.component('inscription-page', InscriptionPage);
Vue.component('cgv-page', CgvPage);
Vue.component('page-header', PageHeader);

const i18n = config.initI18N(Vue);
const store = config.initVueXStore(Vue);

const alertService = new AlertService(store);
const translationService = new TranslationService(store, i18n);
const loginService = new LoginService();
const accountService = new AccountService(store, translationService, (<any>Vue).cookie, router);

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    next('/not-found');
  }

  // remove call to /api/account at application start
  // if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
  //   accountService.hasAnyAuthorityAndCheckAuth(to.meta.authorities).then(value => {
  //     if (!value) {
  //       sessionStorage.setItem('requested-url', to.fullPath);
  //       next('/forbidden');
  //     } else {
  //       next();
  //     }
  //   });
  // } else {
  //   // no authorities, so just proceed
  //   next();
  // }
  next();
});

// Global event bus. Used to pass data from sibling components (with no parent component in common).
Vue.prototype.$eventHub = new Vue();

// Filter to display Date in views
Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY');
  }
});

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm');
  }
});

/* tslint:disable */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,
    activateService: () => new ActivateService(),
    registerService: () => new RegisterService(),
    userService: () => new UserManagementService(),
    auditsService: () => new AuditsService(),
    // healthService: () => new HealthService(),
    // configurationService: () => new ConfigurationService(),
    // logsService: () => new LogsService(),
    // metricsService: () => new MetricsService(),
    alertService: () => alertService,
    translationService: () => translationService,
    serviceRegionalService: () => new ServiceRegionalService(),
    examCenterService: () => new ExamCenterService(),
    examSessionService: () => new ExamSessionService(),
    paymentService: () => new PaymentService(),
    inscriptionService: () => new InscriptionService(),
    autocompletionLocationService: () => new AutocompletionLocationService(),
    jhiDataUtils: () => new JhiDataUtils(),
    dateUtils: () => new DateUtils(),
    captchetatService: () => new CaptchetatService(),
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    applicationService: () => new ApplicationService(),
  },
  i18n,
  store,
});
